import { fetchProfileTags } from "#api/tags";

export async function getTags(service: string, profileID: string) {
  const result = await fetchProfileTags(service, profileID);

  return result;
}
